"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var news_service_1 = __importDefault(require("./news.service"));
/**
 * Solimat-dev-news(Swagger)
 * ====================================
 * Path: https://solimat-dev-news.azurewebsites.net
 */
var News = {
    NewsService: news_service_1.default
};
exports.default = News;
